import React from 'react';
import Button from '../../../components/ui/Button';
import { ModalShell } from '../../../components/ui/ModalFrame';
import { MODAL_LAYER } from '../../../constants/modalLayers';
import { MODAL_DIALOG_ACTIONS_END } from '../../../constants/layoutSpacing';

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {string} props.message
 * @param {'success'|'error'} props.variant
 * @param {() => void} props.onOk
 */
const SignatureCancelFeedbackDialog = ({ open, message, variant, onOk }) => {
  if (!open) return null;

  return (
    <ModalShell
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="bg-card rounded-lg max-w-md w-full p-6 shadow-elevation-lg"
    >
      <p
        className={`text-sm mb-6 ${
          variant === 'error' ? 'text-destructive' : 'text-foreground'
        }`}
      >
        {message}
      </p>

      <div className={MODAL_DIALOG_ACTIONS_END}>
        <Button variant="default" onClick={onOk}>
          OK
        </Button>
      </div>
    </ModalShell>
  );
};

export default SignatureCancelFeedbackDialog;
